if (!process.env.VUE_APP_IS_WEB) {
  var bookshelf = require("../database/index-extended");
}
import remote from "@/database/remote-db";
import links from "@/links/links";

export default {
  methods: {
    remoteEntity(entity, link) {
      return new Promise(tableIsDone =>
        remote
          .getLocalTableStatus(entity)
          .then(entiyStatus => {
            // if not done (2 = done)
            if (entiyStatus != 2) {
              remote
                .getRemoteDB(entity, link)
                .then(entiySaved => {
                  if (entiySaved == "done") {
                    remote.setLocalTableStatus(entity, 2).then(statusSaved => {
                      tableIsDone(true);
                    });
                  }
                })
                .catch(err => {
                  console.log("err", err);
                });
            } else {
              // table was synced already
              tableIsDone(true);
            }
          })
          .catch(err => {
            console.log("err", err);
          })
      );
    },
    remoteDB() {
      return new Promise((resolve, reject) => {
        this.progressValue = 1;
        // put in "remote_db" tables that needed to get data from remote
        remote.initLocalTables().then(async res => {
          this.progressValue = 3;

          // start getting remote DB
          await this.remoteEntity("Building", links.BUILDING_DOWNLOAD());
          this.progressValue = 9;

          await this.remoteEntity("BuildingLot", links.BUILDING_LOT_DOWNLOAD());
          this.progressValue = 15;

          await this.remoteEntity("BuildingOwner", links.BUILDING_OWNER_DOWNLOAD());
          this.progressValue = 21;

          await this.remoteEntity(
            "BuildingOwnerBuildingLot",
            links.BUILDING_OWNER_BUILDING_LOT_DOWNLOAD()
          );
          this.progressValue = 27;

          await this.remoteEntity(
            "BuildingOwnerVotingRight",
            links.BUILDING_OWNER_VOTING_RIGHT_DOWNLOAD()
          );
          this.progressValue = 33;

          await this.remoteEntity("Contact", links.CONTACT_DOWNLOAD());
          this.progressValue = 39;

          await this.remoteEntity("Majority", links.MAJORITY_DOWNLOAD());
          this.progressValue = 45;

          await this.remoteEntity("Mandate", links.MANDATE_DOWNLOAD());
          this.progressValue = 51;

          await this.remoteEntity("Media", links.MEDIA_DOWNLOAD());
          this.progressValue = 57;

          await this.remoteEntity("Tag", links.TAG_DOWNLOAD());
          this.progressValue = 63;

          await this.remoteEntity("VotingCategory", links.VOTING_CATEGORY_DOWNLOAD());
          this.progressValue = 69;

          await this.remoteEntity("ResolutionCatalog", links.RESOLUTION_CATALOG_DOWNLOAD());
          this.progressValue = 75;

          await this.remoteEntity("ResolutionCatalogTag", links.RESOLUTION_CATALOG_TAG_DOWNLOAD());
          this.progressValue = 81;

          await this.remoteEntity("Resolution", links.RESOLUTION_DOWNLOAD());
          this.progressValue = 87;

          await this.remoteEntity("ResolutionVote", links.RESOLUTION_VOTE_DOWNLOAD());
          this.progressValue = 93;

          await this.remoteEntity("Meeting", links.MEETING_DOWNLOAD());
          this.progressValue = 97;

          await this.remoteEntity("MeetingGuest", links.MEETING_GUEST_DOWNLOAD());
          this.progressValue = 98;

          await this.remoteEntity("MeetingResolution", links.MEETING_RESOLUTION_DOWNLOAD());
          this.progressValue = 100;

          resolve(true);
        });
      });
    },
  },
};
